<template>
  <div>
    <h1>{{title}}</h1>
    <hr>
  </div>
</template>

<script>
export default {
  name: 'TitleText',
  props: ['title']
}
</script>

<style scoped lang="stylus">
  div
    width 127px
    text-align center
    h1
      font-size 30px
      font-weight 500
      margin-bottom 17px
    hr
      width 119px
      display inline-block
      border 3px solid #cb212f
      margin 0 0 27px 0
</style>



// WEBPACK FOOTER //
// src/pages/aboutUs/components/TitleText.vue